import { render } from "./DashboardOrdersBlock.vue?vue&type=template&id=d96473ac&ts=true"
import script from "./DashboardOrdersBlock.vue?vue&type=script&lang=ts"
export * from "./DashboardOrdersBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.27_vue@3.5.27_typescript@5.9.3__webpack@5.105.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__